import React, {useEffect, useState} from 'react';

function ContactContainer(props) {
    const [isEditing, setIsEditing] = useState(false);
    const [customerData, setCustomerData] = useState({name: "n/a",
        companyName: "n/a",
        companyAddress: "n/a",
        email: "n/a",
        telephone: "n/a",
        lastLogin: "n/a"})

    useEffect(() => {
        if(props.customerInformation) {
            setCustomerData(props.customerInformation);
        }
    }, [props.customerInformation]);
    const handleEdit = () => {
        setIsEditing(true);
    };

    // Styles based on the screenshot
    const styles = {
        container: {
            minHeight: 350,
            backgroundColor: '#fff',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            padding: '24px',
            marginBottom: '20px',
            position: 'relative', // Add positioning context for absolute positioning
            display: 'flex',
            flexDirection: 'column'
        },
        header: {
            marginBottom: '24px'
        },
        title: {
            fontSize: '18px',
            fontWeight: '600',
            color: 'rgb(52, 71, 103)',
            margin: '0 0 4px 0',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
        },
        subtitle: {
            fontSize: '15px',
            color: '#777',
            margin: '0',
            fontWeight: '400',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
        },
        infoContainer: {
            backgroundColor: 'rgb(248, 249, 250)',
            borderRadius: '6px',
            padding: '24px',
            marginBottom: '28px',
            paddingBottom: '15px'
        },
        infoHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '16px'
        },
        customerName: {
            fontSize: '15px',
            fontWeight: '600',
            color: 'rgb(52, 71, 103)',
            margin: '0',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
        },
        editButton: {
            backgroundColor: 'transparent',
            border: 'none',
            color: 'rgb(123, 128, 154)',
            cursor: 'pointer',
            fontSize: '13px',
            display: 'flex',
            alignItems: 'center',
            padding: '4px 8px',
            borderRadius: '4px'
        },
        editIcon: {
            marginRight: '4px'
        },
        infoRow: {
            marginBottom: '5px',
            display: 'flex'
        },
        infoLabel: {
            color: 'rgb(123, 128, 154)',
            fontSize: '13px',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            fontWeight: '300'
        },
        infoValue: {
            color: 'rgb(52, 71, 103)',
            fontSize: '13px',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            fontWeight: '500',
            marginLeft: 12
        },
        footer: {
            display: 'flex',
            alignItems: 'center',
            color: '#999',
            fontSize: '11px',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            marginTop: 'auto', // Push to bottom of container
        },
        footerIcon: {
            marginRight: '6px',
            display: 'flex',
            alignItems: 'center'
        },
        separator: {
            borderTop: '0px solid rgba(0, 0, 0, 0.12)',
            borderRight: '0px solid rgba(0, 0, 0, 0.12)',
            borderLeft: '0px solid rgba(0, 0, 0, 0.12)',
            backgroundImage: 'linear-gradient(to right, rgba(23, 23, 23, 0), rgba(23, 23, 23, 0.4), rgba(23, 23, 23, 0))',
            height: '0.1rem',
            backgroundColor: 'transparent',
            marginTop: 'auto', // Push separator to bottom before footer
            marginBottom: '15px', // Fixed distance between separator and footer
            borderBottom: 'none',
            opacity: '0.25',
            width: '100%'
        },
        contentWrapper: {
            flex: '1', // Take available space
            display: 'flex',
            flexDirection: 'column',
        },
        footerWrapper: {
            marginTop: 'auto', // Push to bottom
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.contentWrapper}>
                <div style={styles.header}>
                    <h2 style={styles.title}>{"Customer information"}</h2>
                </div>

                <div style={styles.infoContainer}>
                    <div style={styles.infoHeader}>
                        <h3 style={styles.customerName}>{customerData.name}</h3>
                        {/*<button style={styles.editButton} onClick={handleEdit}>*/}
                        {/*    <span style={styles.editIcon}>*/}
                        {/*      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
                        {/*        <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="#777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>*/}
                        {/*        <path d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z" stroke="#777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>*/}
                        {/*      </svg>*/}
                        {/*    </span>*/}
                        {/*    EDIT*/}
                        {/*</button>*/}
                    </div>

                    <div style={styles.infoRow}>
                        <span style={styles.infoLabel}>Company name:</span>
                        <span style={styles.infoValue}>{customerData.companyName}</span>
                    </div>

                    <div style={styles.infoRow}>
                        <span style={styles.infoLabel}>Company address:</span>
                        <span style={styles.infoValue}>{customerData.companyAddress}</span>
                    </div>

                    <div style={styles.infoRow}>
                        <span style={styles.infoLabel}>Email address:</span>
                        <span style={styles.infoValue}>{customerData.email}</span>
                    </div>

                    <div style={styles.infoRow}>
                        <span style={styles.infoLabel}>Telephone number:</span>
                        <span style={styles.infoValue}>{customerData.telephone}</span>
                    </div>
                </div>
            </div>

            <div style={styles.footerWrapper}>
                <div style={styles.separator}></div>
                <div style={styles.footer}>
                    <span style={styles.footerIcon}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12 6V12L16 14" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </span>
                    Last login {customerData.lastLogin}
                </div>
            </div>
        </div>
    );
}

export default ContactContainer;